import { Action } from '@ngrx/store';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import { IApiAutomationQueryParams } from '../shared/api-automation.model';
import { ActivityCRUDInterface } from '../../../../shared/component/filter/filter.class';
import { IApiAutomationOption } from '../shared/api-automation.model';
import {
  IFaultCodeMapping,
  IFaultCodeMappingRow,
} from '../../../../view/settings/api-automation-settings/fault-code-mapping/fault-code-mapping.model';
import { TaskFilterCRUDInterface } from '../../../../shared/component/filter/filter.class';

export enum ActionTypes {
  FAULT_CODE_MAPPINGS_DATA_LOADING = '[FAULT_CODE_MAPPINGS] FAULT_CODE_MAPPINGS DATA LOADING',
  FAULT_CODE_MAPPINGS_DATA_LOADED = '[FAULT_CODE_MAPPINGS] FAULT_CODE_MAPPINGS DATA LOADED',
  GET_FAULT_CODE_MAPPING = '[FAULT_CODE_MAPPINGS] GET_FAULT_CODE_MAPPING LOADING',
  GET_FAULT_CODE_MAPPING_COMPLETED = '[FAULT_CODE_MAPPINGS] GET_FAULT_CODE_MAPPING COMPLETED',
  ADD_FAULT_CODE_MAPPING = '[FAULT_CODE_MAPPINGS] ADD_FAULT_CODE_MAPPING',
  ADD_FAULT_CODE_MAPPING_COMPLETED = '[FAULT_CODE_MAPPINGS] ADD_FAULT_CODE_MAPPING COMPLETED',
  EDIT_FAULT_CODE_MAPPING = '[FAULT_CODE_MAPPINGS] EDIT_FAULT_CODE_MAPPING',
  EDIT_FAULT_CODE_MAPPING_COMPLETED = '[FAULT_CODE_MAPPINGS] EDIT_FAULT_CODE_MAPPING COMPLETED',
  DELETE_FAULT_CODE_MAPPINGS = '[FAULT_CODE_MAPPINGS] DELETE_FAULT_CODE_MAPPINGS',
  DELETE_FAULT_CODE_MAPPINGS_COMPLETED = '[FAULT_CODE_MAPPINGS] DELETE_FAULT_CODE_MAPPINGS COMPLETED',
  ACTIVITIES_DATA_LOADING = '[FAULT_CODE_MAPPINGS] ACTIVITIES DATA LOADING',
  ACTIVITIES_DATA_COMPLETED = '[FAULT_CODE_MAPPINGS] ACTIVITIES DATA COMPLETED',
  TASKS_DATA_LOADING = '[FAULT_CODE_MAPPINGS] TASKS DATA LOADING',
  TASKS_DATA_COMPLETED = '[FAULT_CODE_MAPPINGS] TASKS DATA COMPLETED',
  TASK_LOOKUP_DATA_LOADING = '[FAULT_CODE_MAPPINGS] TASK_LOOKUP DATA LOADING',
  TASK_LOOKUP_DATA_COMPLETED = '[FAULT_CODE_MAPPINGS] TASK_LOOKUP DATA COMPLETED',
  FETCH_ERROR = '[FAULT_CODE_MAPPINGS] FETCH ERROR',
}

export class FaultCodeMappingsLoading implements Action {
  readonly type = ActionTypes.FAULT_CODE_MAPPINGS_DATA_LOADING;

  constructor(public params: IApiAutomationQueryParams) {}
}

export class FaultCodeMappingsLoaded implements Action {
  readonly type = ActionTypes.FAULT_CODE_MAPPINGS_DATA_LOADED;

  constructor(public payload: GetManyResponseInterface<IFaultCodeMapping>) {}
}

export class GetFaultCodeMapping implements Action {
  readonly type = ActionTypes.GET_FAULT_CODE_MAPPING;

  constructor(public recordId: number) {}
}

export class GetFaultCodeMappingCompleted implements Action {
  readonly type = ActionTypes.GET_FAULT_CODE_MAPPING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IFaultCodeMapping>) {}
}
export class AddFaultCodeMapping implements Action {
  readonly type = ActionTypes.ADD_FAULT_CODE_MAPPING;

  constructor(
    public record: IFaultCodeMappingRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class AddFaultCodeMappingCompleted implements Action {
  readonly type = ActionTypes.ADD_FAULT_CODE_MAPPING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IFaultCodeMapping>) {}
}
export class EditFaultCodeMapping implements Action {
  readonly type = ActionTypes.EDIT_FAULT_CODE_MAPPING;

  constructor(
    public recordId: number,
    public record: IFaultCodeMappingRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class EditFaultCodeMappingCompleted implements Action {
  readonly type = ActionTypes.EDIT_FAULT_CODE_MAPPING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IFaultCodeMapping>) {}
}
export class DeleteFaultCodeMappings implements Action {
  readonly type = ActionTypes.DELETE_FAULT_CODE_MAPPINGS;

  constructor(public payload: number[]) {}
}

export class DeleteFaultCodeMappingsCompleted implements Action {
  readonly type = ActionTypes.DELETE_FAULT_CODE_MAPPINGS_COMPLETED;

  constructor(
    public isBulk: boolean,
    public response: BulkResponseDataInterface,
  ) {}
}
export class ActivitiesDataLoading implements Action {
  readonly type = ActionTypes.ACTIVITIES_DATA_LOADING;

  constructor() {}
}

export class ActivitiesDataCompleted implements Action {
  readonly type = ActionTypes.ACTIVITIES_DATA_COMPLETED;

  constructor(public payload: ActivityCRUDInterface[]) {}
}
export class TasksDataLoading implements Action {
  readonly type = ActionTypes.TASKS_DATA_LOADING;

  constructor(public activityId: number) {}
}

export class TasksDataCompleted implements Action {
  readonly type = ActionTypes.TASKS_DATA_COMPLETED;

  constructor(public payload: TaskFilterCRUDInterface[]) {}
}
export class TaskLookupDataLoading implements Action {
  readonly type = ActionTypes.TASK_LOOKUP_DATA_LOADING;

  constructor(public taskIds: number[]) {}
}

export class TaskLookupDataCompleted implements Action {
  readonly type = ActionTypes.TASK_LOOKUP_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class FetchError implements Action {
  readonly type = ActionTypes.FETCH_ERROR;

  constructor(public errorAction: ActionTypes) {}
}

export type FaultCodeMappingActions =
  | FaultCodeMappingsLoading
  | FaultCodeMappingsLoaded
  | GetFaultCodeMapping
  | GetFaultCodeMappingCompleted
  | AddFaultCodeMapping
  | AddFaultCodeMappingCompleted
  | EditFaultCodeMapping
  | EditFaultCodeMappingCompleted
  | DeleteFaultCodeMappings
  | DeleteFaultCodeMappingsCompleted
  | ActivitiesDataLoading
  | ActivitiesDataCompleted
  | TasksDataLoading
  | TasksDataCompleted
  | TaskLookupDataLoading
  | TaskLookupDataCompleted
  | FetchError;
